import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=4a4fef78&scoped=true"
import script from "./JobsTable.vue?vue&type=script&lang=js"
export * from "./JobsTable.vue?vue&type=script&lang=js"
import style0 from "./JobsTable.vue?vue&type=style&index=0&id=4a4fef78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fef78",
  null
  
)

export default component.exports